module.exports = __webpack_public_path__ + "media/1x1/bo-eab17936.svg";